var _ellipse, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 17.5,
    rx: 7,
    ry: 3.5,
    stroke: "#C7CBD7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 4,
    stroke: "#C7CBD7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3403 4.26562C17.2519 4.43755 18.7504 6.04374 18.7505 8C18.7505 10.0709 17.0714 11.7498 15.0005 11.75C14.6089 11.75 14.2313 11.6894 13.8765 11.5781C14.3282 11.1953 14.7213 10.7465 15.0435 10.2471C16.2661 10.2239 17.2505 9.22814 17.2505 8C17.2504 7.07941 16.6967 6.28874 15.9048 5.94043C15.799 5.34729 15.6067 4.7847 15.3403 4.26562Z",
    fill: "#C7CBD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7524 13.2705C17.1925 13.3418 18.5098 13.6142 19.5317 14.04C20.1286 14.2888 20.6609 14.6039 21.0552 14.9922C21.4521 15.3833 21.7504 15.8937 21.7505 16.5C21.7505 17.1063 21.4521 17.6167 21.0552 18.0078C20.6609 18.3961 20.1285 18.7112 19.5317 18.96C19.2144 19.0922 18.8677 19.2081 18.4985 19.3096C18.8127 18.7588 18.9878 18.1695 18.9976 17.5547C19.4629 17.3561 19.7961 17.1418 20.0024 16.9385C20.2124 16.7316 20.2505 16.5839 20.2505 16.5C20.2504 16.4161 20.2124 16.2684 20.0024 16.0615C19.7896 15.8519 19.4431 15.6284 18.9546 15.4248C18.7073 15.3218 18.4323 15.2278 18.1343 15.1445C17.5699 14.4181 16.753 13.7792 15.7524 13.2705Z",
    fill: "#C7CBD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsAlt);
export default __webpack_public_path__ + "static/media/clients-alt.0e660e946c5b72aa4e335c321f498c2f.svg";
export { ForwardRef as ReactComponent };